<template>
  <div class="pdf" v-if="laoclUrl">
    <pdf ref="pdf" v-for="i in numPages" :key="i" :src="laoclUrl" :page="i" :rotate="pageRotate"></pdf>
    <div class="pdf_footer">
      <div class="operate">
        <div class="btn" @click.stop="clock">顺时针</div>
        <div class="btn" @click.stop="counterClock">逆时针</div>
        <div class="btn" v-if="isIos" @click="clipboard(pdfUrl)">复制链接</div>
        <div class="btn" v-else @click="fileDownload(pdfParam, pdfUrl)">下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf-signature";
import CMapReaderFactory from "vue-pdf-signature/src/CMapReaderFactory.js";
import { previewPdf } from "@/api/user";
export default {
  name: "pdfPreview",
  props: {
    // 当前pdf的路径
    pdfUrl: {
      type: String,
      default: ""
    },
    pdfParam: {
      type: Object,
      default: () => {}
    },
    isIos: {
      type: Boolean,
      default: true
    }
  },
  components: {
    pdf
  },
  data() {
    return {
      // 当前页数
      numPages: 0,
      // 预览路径
      laoclUrl: "",
      // 总页数
      pageTotalNum: 1,
      // 当前页数
      pageNum: 0,
      // 加载进度
      loadedRatio: 0,
      // 页面加载完成
      curPageNum: 0,
      // 放大系数 默认百分百
      scale: 100,
      // 旋转角度 ‘90’的倍数才有效
      pageRotate: 0,
      // 单击内部链接时触发 (目前我没有遇到使用场景)
      page: 0
    };
  },
  watch: {},
  computed: {},
  created() {
    this.laoclUrl = this.pdfUrl;
  },
  mounted() {
    this.getNumPages();
  },
  methods: {
    clipboard(url) {
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$toast.success("复制成功");
      oInput.remove();
    },
    getNumPages() {
      let loadingTask = pdf.createLoadingTask({ url: this.laoclUrl, CMapReaderFactory });
      // 网上查询 都没有加promise执行的整页渲染 emmmm... 不知道他们怎么运行的
      loadingTask.promise.then(pdf => {
        this.laoclUrl = loadingTask;
        this.pageNum = pdf.numPages;
      })
      .catch((err) => {
        console.error("pdf加载失败", err);
      });
      setTimeout( ()=> {
        this.timer = setInterval( () => {
          this.numPages +=1;
          if(this.pageNum == this.numPages) {
            clearInterval(this.timer)
          }
        }, 1000)
      }, 1000)
    },
    //下载PDF
    async fileDownload(pdfParam, pdfUrl) {
      let pdf = document.createElement("a");
      pdf.href = pdfUrl;
      // console.log("previewPdf--", data, , pdf.href);
      pdf.setAttribute("id", "startTelMedicine");
      pdf.setAttribute("onclick", "window.open()");
      // console.log(pdf);
      // 防止反复添加
      if (document.getElementById("startTelMedicine")) {
        document.body.removeChild(document.getElementById("startTelMedicine"));
      }
      document.body.appendChild(pdf);
      pdf.click();
      document.body.removeChild(pdf);
      window.URL.revokeObjectURL(herf);
      // const data = await previewPdf(pdfParam);
      // let content = data; //arraybuffer类型数据
      // let resBlob = new Blob([content]);
      // let reader = new FileReader();
      // reader.readAsText(resBlob, "utf-8");
      // reader.onload = () => {
      //   try {
      //     // 判断是否可以转化为json格式，可以就说明不是文件流，错误返回值
      //     let res = JSON.parse(reader.result);
      //     console.log(res);
      //     this.$message.destroy();
      //     this.$message.error(res.message);
      //   } catch {
      //     // 报错说明不能转化为json，是文件流，下载文件
      //     console.log("res status", data);
      //     // let blob = new Blob([data]); // 原 此种方式在pc端可以下载，但是手机端不行
      //     let blob = new Blob([data], {
      //       type: "application/pdf"
      //     }); //
      //     const blobUrl = window.URL.createObjectURL(blob);
      //     const a = document.createElement("a");
      //     a.style.display = "none";
      //     a.download = fileName;
      //     a.href = blobUrl;
      //     a.click();
      //   }
      // };
    },

    // 顺时针选中角度
    clock() {
      this.pageRotate += 90;
    },
    // 逆时针旋转角度
    counterClock() {
      this.pageRotate -= 90;
    }
  }
};
</script>

<style lang="less" scoped>
.pdf_footer {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 0;
  background-color: rgba(255, 255, 255, 0.5);
  .info {
    display: flex;
    flex-wrap: wrap;
    div {
      width: 30%;
    }
  }
  .operate {
    margin: 10px 0 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    div {
      // width: 80px;
      text-align: center;
      font-size: 15px;
    }
    .btn {
      cursor: pointer;
      margin: 5px 10px;
      width: 20%;
      border-radius: 10px;
      padding: 5px;
      color: #fff;
      background-color: #4285f4;
    }
  }
}
</style>
